import React from 'react';
import styles from '../styles/gameStyles';

// ========================================
// SPトークン表示コンポーネント
// ========================================

interface SPTokensProps {
  active: number;
  rested: number;
  max: number;
  bonus?: number;
}

const SPTokens: React.FC<SPTokensProps> = ({ active, rested, max, bonus = 0 }) => {
  const tokens: React.ReactNode[] = [];
  for (let i = 0; i < max; i++) {
    const isActive = i < active;
    const isRested = i >= active && i < active + rested;
    tokens.push(
      <div
        key={i}
        style={{
          ...styles.spToken,
          background: isActive
            ? 'linear-gradient(135deg, #6b4ce6 0%, #9d4ce6 100%)'
            : isRested
              ? 'linear-gradient(135deg, #444 0%, #666 100%)'
              : 'rgba(30,30,50,0.5)',
          border: isActive ? '2px solid #a78bfa' : '2px solid #444',
          boxShadow: isActive ? '0 0 10px rgba(107,76,230,0.5)' : 'none',
          color: isActive ? '#fff' : '#666',
        }}
      >
        {isActive ? '◆' : isRested ? '◇' : '○'}
      </div>
    );
  }

  // ボーナスSPトークン（金色の☆）
  for (let i = 0; i < bonus; i++) {
    tokens.push(
      <div
        key={`bonus-${i}`}
        style={{
          ...styles.spToken,
          background: 'linear-gradient(135deg, #ffd700 0%, #ffaa00 100%)',
          border: '2px solid #ffe066',
          boxShadow: '0 0 12px rgba(255,215,0,0.6)',
          color: '#fff',
        }}
        title="後攻ボーナスSP"
      >
        ☆
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', justifyContent: 'center' }}>
      {tokens}
    </div>
  );
};

export default SPTokens;
